export const appData = {
  version: '0.1.4',
  elearnings: {
    review: {
      message:
        '<p>Hi [[FIRSTNAME]],</p><p>Can you please review this module?</p><p>Just click the link below</p><p>Thanks!</p>',
    },
  },
  playerTheme: {
    default: {
      id: '',
      name: 'Default Theme',
      tenantId: '',
      banner: 'banner.jpg',
      bgImg: '',
      naviBg: '',
      mobileLogo: '',
      headingMetadata: {
        heading1Font: 'Open Sans, sans-serif',
        heading1Size: '1.8em',
        heading1Color: 'ffffff',
        heading1Weight: 'normal',
        heading2Font: 'Open Sans, sans-serif',
        heading2Size: '1.4em',
        heading2Color: 'ffffff',
        heading2Weight: 'normal',
      },
      bodyMetadata: {
        bodyFont: 'Open Sans, sans-serif',
        bodySize: '1.1em',
        bodyColor: '000000',
        bodyFontWeight: 'normal',
      },
      tipMetadata: {
        tipboxColor: '000000',
        tipboxBg: 'EDF3FC',
        tipboxSize: '1.3em',
      },
      menuMetadata: {
        menuColor1: '418151',
        menuColor2: '000000',
        menuIconSet: 0,
        isGradientMenu: 1,
        buttonColor: 'ffffff',
      },
      windowMetadata: {
        width: 1024,
        height: 670,
        windowBgColor: 'eaeaea',
      },
      css: '',
      showPoweredBy: 0,
      showHelpDesk: 2,
      isDeleted: null,
      createdAt: '',
      modifiedAt: '',
    },
  },
  commentStatus: {
    new: 0,
    rejected: 1,
    completed: 2,
  },
  helpJson: {
    default: {
      content: [
        {
          id: 'be9fb0c3-c717-46cc-8a7a-d62313ff56aa',
          name: 'general',
          content:
            '<div style="line-height: 1.5em;"><p style="margin: 0px;">Buttons contain useful information which is displayed when moving your cursor over them / by touch on tablet devices.</p><hr style="margin: 5px 0px; border-top: 1px solid #c4c4c4;"><p style="margin: 0px;">Text which is underlined in blue font (<span style="color:#0000FF;"><u>example</u></span>) indicates a hyperlink to a useful document or external site that will open in a new window.</p><hr style="margin: 5px 0px; border-top: 1px solid #c4c4c4;"><p style="margin: 0px;">Text which is underlined in purple font (<span style="color:#9236AF;"><u>example</u></span>) indicates additional useful content such as definitions, which is displayed when clicked / touch on tablet devices.</p><hr style="margin: 5px 0px; border-top: 1px solid #c4c4c4;"><p style="margin: 0px;">Interactive images will respond to your cursor movements, mouse clicks or touch on tablet devices. These can be identified by the icon&nbsp;<em><strong>&nbsp;<img alt="" data-cke-saved-src="/learning_module_template/css/images/inter-icon-small.png" src="/learning_module_template/css/images/inter-icon-small.png" style="margin-bottom: -10px;"></strong></em><br></p></div>',
          createdAt: '2022-05-17T05:15:21.200Z',
          modifiedAt: '2022-05-17T05:15:21.200Z',
        },
        {
          id: '14492758-e65a-49c2-bb2a-db7c6001be72',
          name: 'system',
          content:
            '<div style="line-height: 1.5em;"><h4 style="margin: 0px 0 5px 0; font-weight: bold;">Browser Requirements</h4><p>You can access this courseware using any common Internet browser, such as Google Chrome, Mozilla Firefox or Safari. The following versions are supported:</p><ul><li>Google Chrome, most recent stable version (PC and Mac)</li><li>Mozilla Firefox, most recent stable version (PC and Mac)</li><li>Safari 13&nbsp;or newer (Mac and iPad)</li></ul><p>Earlier browser versions may have limited functionality and ELMO Support will not investigate issues related to unsupported browsers.</p><h4 style="margin: 0px 0 5px 0; font-weight: bold;">Browser Settings</h4><p>All browsers must have cookies and JavaScript enabled.</p><h4 style="margin: 0px 0 5px 0; font-weight: bold;">Screen Resolution</h4><p>A minimum screen resolution of 1024 x 768 is required.</p><h4 style="margin: 0px 0 5px 0; font-weight: bold;">Connectivity</h4><p>A fixed broadband connection is recommended to ensure content loads quickly and smoothly. Mobile connections may result in slow or intermittent access.</p></div>',
          createdAt: '2022-05-17T05:15:21.236Z',
          modifiedAt: '2022-05-17T05:15:21.236Z',
        },
      ],
      faqs: [
        {
          id: '469fd653-3464-42b9-8f4e-62a4470fc5cf',
          question:
            'I completed the Assessment/Quiz a few days ago but never received my certificate.',
          answer:
            "Certificates of completion are emailed to the email address linked to your account upon successful completion of the course. If you didn't receive your certificate, please check your spam or junk folder before contacting your system administrator. ",
          lcmsReferenceIds: { id: 1 },
          faqMetadata: { position: 0, keywords: 'Certificate,Assessment' },
          isDeleted: null,
          createdAt: '2014-03-11T10:18:25.000Z',
          modifiedAt: '2020-04-30T12:38:52.000Z',
        },
        {
          id: '256e0fc2-0c15-4071-9df1-b55ef7ea2adb',
          question:
            'I could not print my certificate after completing the Assessment/Quiz. ',
          answer:
            "You must have Adobe PDF reader installed in order to display your certificate, and be connected to a printer on your network in order to print a copy. If you need to reprint or get a copy of your certificate, search your email inbox by the date you completed the course. If you can't find your certificate, please check your spam or junk folder before contacting your system administrator.",
          lcmsReferenceIds: { id: 2 },
          faqMetadata: { position: 1, keywords: 'Certificate,Print' },
          isDeleted: null,
          createdAt: '2014-03-11T10:21:00.000Z',
          modifiedAt: '2020-04-30T12:38:52.000Z',
        },
        {
          id: '6ba83185-fb20-4384-a888-f18514ad3282',
          question:
            'My module window opens but the content area is blank / navigation is not working.',
          answer:
            'Please check that your internet browser security settings are set to medium or lower, and that you have Javascript enabled under advanced settings.Please also check that your internet browser meets the minimum version requirements (see System Requirements tab). If you have another internet browser installed on your machine, it may be quicker / easier to try again using a different browser.',
          lcmsReferenceIds: { id: 3 },
          faqMetadata: {
            position: 2,
            keywords: 'Loading,Blank,Arrows,Open,Broken',
          },
          isDeleted: null,
          createdAt: '2014-03-11T10:24:22.000Z',
          modifiedAt: '2020-04-30T12:38:52.000Z',
        },
        {
          id: '090bc47c-2976-4c57-a7b4-63d52ab12da7',
          question:
            "After completing the Assessment I receive an error 'You have successfully completed your assessment with a score of X% But your assessment result could not be recorded due to network connection issue.'",
          answer:
            'This issue might be caused by a slow or intermittent internet connection (e.g. wireless or mobile connections).Please try again on a broadband connection (if possible) or at a later time (e.g. during off-peak times). If you continue to experience issues, please submit a helpdesk request via the Contact Us tab.',
          lcmsReferenceIds: { id: 4 },
          faqMetadata: {
            position: 3,
            keywords: 'Record,Error,Network,Issue,Connection',
          },
          isDeleted: null,
          createdAt: '2014-03-11T10:25:24.000Z',
          modifiedAt: '2020-04-30T12:38:52.000Z',
        },
        {
          id: '4a97f719-a0fb-4a9c-8f95-b9397e8547e3',
          question: 'How can I complete a course?',
          answer:
            "Once all the recordable activities within a course has been completed, the course will automatically be marked as 'completed'",
          lcmsReferenceIds: { id: 5 },
          faqMetadata: { position: 4, keywords: 'course,complete,status' },
          isDeleted: null,
          createdAt: '2019-06-11T12:24:52.000Z',
          modifiedAt: '2020-04-30T12:38:52.000Z',
        },
        {
          id: 'b44dffee-f964-43ce-9ad1-28ab61d9bbfe',
          question: 'How to upload a file',
          answer: 'Filemanager',
          lcmsReferenceIds: { id: 7 },
          faqMetadata: {
            position: 5,
            keywords: 'File,Keyword test,Adjust chair movie',
          },
          isDeleted: null,
          createdAt: '2020-04-30T12:39:26.000Z',
          modifiedAt: '2022-05-09T11:40:00.000Z',
        },
        {
          id: 'c69e216e-32b5-4f4d-82f1-bd634fc05005',
          question: 'How many?',
          answer: 'A lot.',
          lcmsReferenceIds: { id: 8 },
          faqMetadata: { position: 6, keywords: 'Helpful' },
          isDeleted: null,
          createdAt: '2021-12-03T21:41:19.000Z',
          modifiedAt: '2021-12-03T21:41:19.000Z',
        },
      ],
    },
  },
  assets: {
    logo: `elmo-logo.svg`,
    banner: `banner.jpg`,
  },
  theme: {
    font: '-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen-Sans,Ubuntu,Cantarell,Helvetica Neue,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol',
  },
  menu: {
    appCourseBuilderKey: 'app.menu.courseBuilder',
    userSignOutKey: 'app.menu.signOut',
  },
  pagination: {
    pages: [10, 20],
    defaultParams: {
      page: 1,
      limit: 10,
      sort: 'name',
      order: 'ASC',
      search: undefined,
    },
  },
};
